import type { PlayerInfo, PlayerInfoUpcoming } from "~/domains/contest/domains/game/domains/common/dfs/types/player";

const isPlayerInfoUpcoming = (playerInfo: PlayerInfo): playerInfo is PlayerInfoUpcoming =>
  playerInfo?.isUpcoming ?? false;

export default isPlayerInfoUpcoming;
